import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';

/**
 * 返回顶部按钮
 */
class ToTopBtnStore extends BaseStore {

  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  use() {
    super.use();
    useMount(() => {
    });
  }
}

export default ToTopBtnStore;
